import {Pipe, PipeTransform} from '@angular/core';
import {RaceRegistration, TypeOfRegistration} from "@model";

@Pipe({
  name: 'registrationType'
})
export class RegistrationTypePipe implements PipeTransform {
  constructor() {
  }

  transform(value?: RaceRegistration): TypeOfRegistration | undefined {
    if (!value) return undefined;
    return RaceRegistration.getTypeOfRegistration(value);

  }
}
